import React from 'react';
import { Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AuthCard = ({ children, title, subtitle }) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827] flex items-center justify-center p-4">
      <div className="bg-[#1f2937]/60 backdrop-blur-sm rounded-2xl p-8 w-full max-w-md border border-gray-700/50 shadow-2xl">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Coffee className="text-[#a15507] w-12 h-12" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-2">
            {t('landing.hero.title')}
          </h1>
          <p className="text-gray-300">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthCard; 